import moment from 'moment';
import numeral from 'numeral';

export const formatNumberInput = (val) => {
  if (val === 0) return val;
  const value = val
    .replace(/^0+(?=\d)/, '')
    .replace('.', ',')
    .replace(/[^0-9/,]+/g, '');
  if (!isNaN(value)) {
    const n = Number(value);
    if (Math.floor(n) === n) return value;
    if (n.toString().split('.')[1].length > 8) {
      return n.toFixed(8);
    }
    return value;
  }
  return value;
};

export const copyToClipboard = (str) => {
  const el = document.createElement('textarea');
  el.value = str;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  document.body.appendChild(el);
  const selected =
    document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false;
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
  if (selected) {
    document.getSelection().removeAllRanges();
    document.getSelection().addRange(selected);
  }
};

export const tablePagination = (currentPage, numOfPages) => {
  let current = currentPage,
    last = numOfPages,
    delta = 2,
    left = current - delta,
    right = current + delta + 1,
    range = [],
    rangeWithDots = [],
    l;

  for (let i = 1; i <= last; i++) {
    if (i === 1 || i === last || (i >= left && i < right)) {
      range.push(i);
    }
  }

  for (let i of range) {
    if (l) {
      if (i - l === 2) {
        rangeWithDots.push(l + 1);
      } else if (i - l !== 1) {
        rangeWithDots.push('...');
      }
    }
    rangeWithDots.push(i);
    l = i;
  }

  return rangeWithDots;
};

export const formatDateTime = (value, timeString, detailed) => {
  let formattedDate = '';
  if (detailed) {
    switch (timeString) {
      case 'year':
        formattedDate = moment(value).format('DD MMM YYYY');
        break;
      case 'month':
        formattedDate = moment(value).format('Do MMM LT');
        break;
      case 'week':
        formattedDate = moment(value).format('dddd LT');
        break;
      case 'day':
        formattedDate = moment(value).format('DD MMM LT');
        break;
      default:
        break;
    }
    return formattedDate;
  } else {
    switch (timeString) {
      case 'year':
        formattedDate = moment(value).format('MMM YYYY');
        break;
      case 'month':
        formattedDate = moment(value).format('MMM Do');
        break;
      case 'week':
        formattedDate = moment(value).format('dddd');
        break;
      case 'day':
        formattedDate = moment(value).format('LT');
        break;
      default:
        break;
    }
    return formattedDate;
  }
};

export const formatDayCount = (day) => {
  let formattedDaySpell = '';
  switch (day) {
    case 1:
      formattedDaySpell = 'global_day';
      break;
    case 2:
      formattedDaySpell = 'global_more_days';
      break;
    case 3:
      formattedDaySpell = 'global_more_days';
      break;
    case 4:
      formattedDaySpell = 'global_more_days';
      break;

    default:
      formattedDaySpell = 'global_days';
      break;
  }

  return formattedDaySpell;
};

export const getColorByStatus = (status) => {
  let colorOfMark = '';

  switch (status) {
    case 'buyer_bought_immediately':
      colorOfMark = 'GREEN';
      break;
    case 'buyer_suggested_price':
      colorOfMark = '';
      break;
    case 'seller_agreed_price':
      colorOfMark = 'GREEN';
      break;
    case 'seller_suggested_price':
      colorOfMark = '';
      break;
    case 'buyer_bought_after_bidding':
      colorOfMark = 'GREEN';
      break;
    case 'declined_by_seller':
      colorOfMark = 'RED';
      break;
    case 'declined_by_buyer':
      colorOfMark = 'RED';
      break;
    case 'sold_to_another_bidder':
      colorOfMark = 'RED';
      break;
    case 'expired':
      colorOfMark = 'RED';
      break;
    case 'offer_cancelled_by_seller':
      colorOfMark = 'RED';
      break;
    case 'offer_cancelled_by_system':
      colorOfMark = 'RED';
      break;

    default:
      break;
  }

  return colorOfMark;
};

export const formatDashboardNumber = (number) => numeral(Number(number)).format('0,00.00');
